function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 5.5,
  y: 10.5,
  width: 13,
  height: 10,
  rx: 3.5,
  stroke: "#D61F26"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9V11H15V9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9V11H8V9Z",
  fill: "#D61F26"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 14.501C13.5 15.3294 12.8284 16.001 12 16.001C11.1716 16.001 10.5 15.3294 10.5 14.501C10.5 13.6725 11.1716 13.001 12 13.001C12.8284 13.001 13.5 13.6725 13.5 14.501Z",
  stroke: "#D61F26"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 16H12.5V18C12.5 18.2761 12.2761 18.5 12 18.5C11.7239 18.5 11.5 18.2761 11.5 18V16Z",
  fill: "#D61F26"
});
const SvgBlockingNonStatus = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlockingNonStatus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blockingNonStatus.4ac31e49.svg";
export { ForwardRef as ReactComponent };